import $ from 'jquery'

window.jQuery = $
import '../src/views/pages/mobile';
